import axios from 'axios';
import { getCustomerPortalApi } from '../config';

// Get customer portal API configuration
const customerPortalApi = getCustomerPortalApi();

// Create dedicated axios instance for customer portal API
const customerPortalApiService = axios.create({
  baseURL: customerPortalApi.baseUrl,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  timeout: 30000 // 30 second timeout
});

// Add request interceptor for debugging and CORS handling
customerPortalApiService.interceptors.request.use(
  (config) => { 
    return config;
  },
  (error) => {
    console.error('[Customer Portal API] Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for debugging and error handling
customerPortalApiService.interceptors.response.use(
  (response) => { 
    return response;
  },
  (error) => {
    console.error('[Customer Portal API] Response Error:', error);
    
    // Handle common error scenarios
    if (error.code === 'ECONNREFUSED' || error.code === 'ENOTFOUND') {
      console.error('[Customer Portal API] Connection failed - check if API server is running');
    }
    
    if (error.response?.status === 404) {
      console.error('[Customer Portal API] Endpoint not found - check URL configuration');
    }
    
    return Promise.reject(error);
  }
);

export default customerPortalApiService;
